// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"440":"lang-[request]","716":"unslug"}[chunkId] + "." + {"440":"8a3e84da","716":"838bb935"}[chunkId] + ".js";
};